import Base from './components/cells/Base';
import Tag from './components/cells/Tag';

export default function TagCell() {}

TagCell.prototype.init = function (params) {
    this.eGui = Base(Tag(params), params);
    return;
};

TagCell.prototype.getGui = function () {
    return this.eGui;
};
